var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconArchive = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#787878"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 3.765h-.941V1.412a.47.47 0 00-.47-.47H1.411a.47.47 0 00-.47.47v2.353H0V1.412C0 .633.633 0 1.412 0h13.176C15.367 0 16 .633 16 1.412v2.353m-2.353 9.411H2.353A1.413 1.413 0 01.94 11.765v-8h.941v8c0 .259.211.47.47.47h11.295a.47.47 0 00.47-.47v-8h.942v8c0 .778-.634 1.411-1.412 1.411"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.882 6.588H6.118a.47.47 0 110-.94h3.764a.47.47 0 110 .94M0 2.824h16v.94H0z"
}))));

export default SvgIconArchive;